import React from 'react';
import PropTypes from 'prop-types';
import {
  Avatar,
  Cushion,
  Grid,
  Hide,
  Rectangle,
  TextOverflow,
  Typography,
} from '@pitchero/react-ui';
import ProfileLink from './profile-link';

const ScoreCardBowler = ({
  avatar,
  economy,
  extrasSummary,
  gridColumns,
  gridResponsive,
  hasExtrasSummary,
  maidens,
  name,
  overs,
  runs,
  wickets,
  id,
  teamId,
}) => (
  <Rectangle fill="white" borderBottom="thinLightGrey">
    <Cushion
      all="small"
      left="medium"
      responsive={[{ maxWidth: 'tab', props: { left: 'small' } }]}
      component="div"
    >
      <Grid columns={gridColumns} responsive={gridResponsive} alignItems="center">
        <Grid
          columns="48px 1fr"
          responsive={[{ maxWidth: 'tab', props: { display: 'block' } }]}
          columnGap="medium"
          alignItems="center"
        >
          <Hide maxWidth="tab" component="div">
            <ProfileLink teamId={teamId} name={name} playerId={id}>
              <Avatar image={avatar} alt={name} />
            </ProfileLink>
          </Hide>
          <ProfileLink teamId={teamId} name={name} playerId={id}>
            <Typography preset="subtitle--small" color="black" component="div">
              <TextOverflow maxWidth="100%">{name}</TextOverflow>
            </Typography>
          </ProfileLink>
        </Grid>
        <Typography preset="body--small" color="dustygrey" component="div" align="center">
          {overs}
        </Typography>
        <Typography preset="body--small" color="dustygrey" component="div" align="center">
          {maidens}
        </Typography>
        <Typography preset="body--small" color="dustygrey" component="div" align="center">
          {runs}
        </Typography>
        <Typography preset="body--small" color="dustygrey" component="div" align="center">
          {wickets}
        </Typography>
        <Typography preset="body--small" color="dustygrey" component="div" align="center">
          {economy}
        </Typography>
        {hasExtrasSummary && (
          <Hide maxWidth="tab">
            <Typography preset="body--small" color="dustygrey" component="div" align="center">
              {extrasSummary}
            </Typography>
          </Hide>
        )}
      </Grid>
    </Cushion>
  </Rectangle>
);

ScoreCardBowler.defaultProps = {
  economy: null,
  extrasSummary: null,
  maidens: null,
  overs: null,
  runs: null,
  wickets: null,
  teamId: null,
};

ScoreCardBowler.propTypes = {
  avatar: PropTypes.string.isRequired,
  economy: PropTypes.string,
  extrasSummary: PropTypes.string,
  gridColumns: PropTypes.string.isRequired,
  gridResponsive: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  hasExtrasSummary: PropTypes.bool.isRequired,
  maidens: PropTypes.number,
  name: PropTypes.string.isRequired,
  overs: PropTypes.string,
  runs: PropTypes.number,
  wickets: PropTypes.number,
  id: PropTypes.string.isRequired,
  teamId: PropTypes.number,
};

export default ScoreCardBowler;
